<template>
	<div id="app">
		<router-view></router-view>
	</div>
</template>

<script>
	export default {
		name: 'app',
		data() {
		    return {};
		},
		mounted(){},
		methods: {}
	}
</script>

<style>
	/* css */
	@import 'static/css/style.css'; /* 公用的-css */
	@import 'static/css/index.css';	/* 首页的-css */
	
	/* 图标 */
	@import 'static/iconfont/iconfont.css';
</style>
